module.exports = __webpack_public_path__ + "static/img/studiesTwo.80d330f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/studiesTwo.png
// module id = +UeO
// module chunks = 1